import { render } from "./MediaOverview.vue?vue&type=template&id=2835c460"
import script from "./MediaOverview.vue?vue&type=script&lang=js"
export * from "./MediaOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__